module.exports = __webpack_public_path__ + "static/media/school.57237dc5.svg";